import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import faceImage from '../../../common/image/Face.svg';
import {
    InfoBox, TaskLink, VimoLink, SkillLink,
} from '../../../common/components';
import {
    getProgram, getCurrentSkills, getTodaysTasks,
} from '../../../common/utils/programUtils';
import urls from '../../../app/urls';
import { green3 } from '../../../app/style/theme';

const styles = theme => ({
    root: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderBottom: theme.borders.normal,
        display: 'flex',
        justifyContent: 'space-between',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            paddingBottom: theme.spacing(1),
        },
    },
    infoBox: {
        flexBasis: `calc(100% / 2 - ${theme.spacing(2)}px)`,
        overflow: 'hidden',
        margin: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            flexBasis: `calc(100% - ${theme.spacing(1)}px)`,
            margin: theme.spacing(0, 0, 1, 0),
        },
    },
    hideOnSmall: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    firstBox: {
        flex: '0 0 calc(50% - 16px)',
        display: 'flex',

        [theme.breakpoints.down('xs')]: {
            flex: '0 0 calc(50% - 8px)',
        },
    },
    firstContentBox: {
        background: theme.colors.green3,
        marginRight: 0,
    },
    links: {
        flex: '1 1 auto',
        margin: theme.spacing(1, 1, 1, 0),
        background: theme.colors.grey2,
        padding: theme.spacing(2),

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 0, 1, 0),
        },
    },
    link: {
        marginBottom: theme.spacing(1),
    },
});

class StudentLine extends React.Component {
    render() {
        const {
            classes, translate, studentData, hasLicense,
        } = this.props;

        const programData = getProgram(studentData);
        const currentSkills = getCurrentSkills(programData);
        const todaysTasks = getTodaysTasks(programData);

        return (
            <div className={classes.root}>
                <div className={classes.firstBox}>
                    <InfoBox
                        className={classnames(classes.infoBox, classes.firstContentBox)}
                        image={faceImage}
                        primary={studentData.name}
                        bigText
                        color={green3}
                        secondary={studentData?.extendedProperties && studentData?.extendedProperties.class ? `${translate('student.class')} ${studentData?.extendedProperties.class}` : null}
                    // link={{ to: `${urls.inside.student.home}/${studentData.id}`, text: translate('dashboard.goToStudent') }}
                    />
                    <div className={classnames(classes.links)}>
                        <VimoLink disabled={!hasLicense} to={`${urls.inside.student.home}/${studentData.id}`} text={translate('dashboard.studentInfo')} forward className={classes.link} />
                        <VimoLink disabled={!hasLicense} to={`${urls.inside.student.home}/${studentData.id}/${urls.inside.student.parts.skills}`} text={translate('dashboard.planASkill')} forward className={classes.link} />
                        <VimoLink disabled={!hasLicense} to={`${urls.inside.student.home}/${studentData.id}/${urls.inside.student.parts.plan}`} text={translate('dashboard.calendarOverview')} forward className={classes.link} />
                        <VimoLink disabled={!hasLicense} to={`${urls.inside.student.home}/${studentData.id}/${urls.inside.student.parts.progress}`} text={translate('dashboard.progression')} forward className={classes.link} />
                    </div>
                </div>

                {currentSkills?.length ? (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.skill')}
                        color={green3}
                    >
                        {currentSkills.map(skill => <SkillLink key={skill?.module?.name} skill={skill} />)}
                    </InfoBox>
                ) : (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.skill')}
                        primary={translate('dashboard.noCurrentSkill')}
                        color={green3}
                    />
                )}

                {hasLicense && todaysTasks?.length ? (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.todaysTasks')}
                        color={green3}
                    >
                        {todaysTasks.map(task => <TaskLink task={task} skillName={task.skillName} studentData={studentData} key={task.id} to={`${urls.inside.student.home}/${studentData.id}/${urls.inside.student.parts.task}/${task.id}`} />)}
                    </InfoBox>
                ) : (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.todaysTask')}
                        primary={translate('dashboard.noTasksToday')}
                        color={green3}
                    />
                )}
            </div>
        );
    }
}

StudentLine.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    studentData: PropTypes.object.isRequired,
    hasLicense: PropTypes.bool,
};

StudentLine.defaultProps = {
    hasLicense: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(StudentLine));
